var _defs, _circle, _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCarsOffRoad(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 58.28 54.78",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #feefe1;\n      }\n\n      .cls-2 {\n        fill: #fc7f11;\n      }\n\n      .cls-3 {\n        fill: #f8b180;\n      }\n    "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 29.14,
    cy: 27.39,
    r: 23.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M29.14,50.89c-12.96,0-23.5-10.54-23.5-23.5S16.18,3.89,29.14,3.89s23.5,10.54,23.5,23.5-10.54,23.5-23.5,23.5ZM29.14,5.39c-12.13,0-22,9.87-22,22s9.87,22,22,22,22-9.87,22-22S41.27,5.39,29.14,5.39Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "car_18495233"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_33",
    className: "cls-2",
    cx: 20.29,
    cy: 32,
    r: 2.92
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_34",
    className: "cls-2",
    cx: 37.73,
    cy: 32,
    r: 2.92
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_645",
    className: "cls-2",
    d: "M43.1,25.73c-1.34-.37-2.71-.61-4.09-.7-.3-.02-.58-.14-.8-.33l-4.23-3.96c-.59-.56-1.37-.87-2.18-.87h-8.86c-.82,0-1.62.31-2.21.87l-4.16,4.02c-.14.13-.31.2-.5.2-1.57,0-2.85,1.27-2.85,2.84,0,0,0,0,0,0v1.88c0,1.57,1.27,2.85,2.85,2.85h.24c0-.07-.03-.13-.03-.24-.16-1.99,1.17-3.8,3.12-4.23,2.17-.49,4.34.87,4.83,3.05.07.3.1.61.1.91,0,.17,0,.33-.03.5h9.43c0-.07-.03-.13-.03-.24-.17-1.99,1.17-3.8,3.12-4.23,2.19-.5,4.37.87,4.86,3.06.07.29.1.59.1.89,0,.17,0,.33-.03.5h.5c1.57,0,2.85-1.27,2.85-2.85h0v-1.24c0-1.24-.79-2.34-1.97-2.72ZM26.4,24.69h-5.47c-.28,0-.5-.24-.5-.52,0-.05.01-.1.03-.15l.8-2.31c.07-.2.26-.33.47-.33h4.63c.27,0,.49.23.5.5v2.31c.02.26-.17.48-.43.5-.01,0-.02,0-.04,0h0ZM28.94,24.19v-2.32c0-.27.23-.49.5-.5h2.68c.43,0,.84.17,1.14.47l2.11,1.98c.2.19.21.52.01.72-.09.1-.22.15-.35.16h-5.6c-.28,0-.5-.23-.51-.51h0Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarsOffRoad);
export default __webpack_public_path__ + "static/media/Cars Off Road.28f089069b96df020e11abeaf0ac26f9.svg";
export { ForwardRef as ReactComponent };